
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"overview"},[_c('h2',[_v("Who sits on the Broadband Deployment Advisory Committee?")]),_v(" "),_c('p',{staticStyle:{"line-height":"130%","padding-top":"5px","font-size":"16px","margin-bottom":"0","padding-bottom":"10px"}},[_v("Three out of every four of the 30 members on the BDAC work for telecommunications companies, trade organizations that represent them or think tanks that argue the same anti-regulatory positons. Only 10 percent of the members are from city or state government. Similar ratios are found on the four working groups, which will submit proposals to reduce local and state wireless regulations, which the BDAC will review and vote on.")]),_v(" "),_c('div',{staticClass:"overviewContainer"},[_c('router-view')],1)])}},
      staticRenderFns: []
    };
  


//////////////////
// WEBPACK FOOTER
// ./src/view/overview.html
// module id = 14
// module chunks = 0